import { Box, Container, Typography } from "@mui/material";
import { TypographyConstants } from "../../../constants/enum";
import styles from "../index.module.css";
import { useId } from "react";
import { FreedoFeatureSkeleton } from "../../../../sharedComponents/template/SkeletonLoader/HomePageSkeletons";

interface featureInterface {
  src?: string;
  content?: any;
  featureKey: string | number;
}

const FreedoContainer = ({ src, content, featureKey }: featureInterface) => {
  return (
    <Box className={styles.featuresContentCard} key={featureKey}>
      <img
        src={src}
        alt=""
        style={{ height: "40px", objectFit: "contain", width: "fit-content" }}
        loading="lazy"
      />

      <Typography
        variant={TypographyConstants.CAPTION}
        fontWeight="500"
        className={styles.typographyFeaturedCard}
      >
        {content}
      </Typography>
    </Box>
  );
};

const FreedoFeature = ({ cmsData, isHomePage }: any) => {
  return (
    <Container sx={{ marginTop: "20px" }}>
      <Box className={styles.featuresContent}>
        {isHomePage ? (
          <FreedoFeatureSkeleton />
        ) : (
          cmsData &&
          cmsData?.map((data: any, index: number) => {
            const randomId = useId();
            return (
              <FreedoContainer
                content={data.heading}
                src={data.image}
                featureKey={randomId}
              />
            );
          })
        )}
      </Box>
    </Container>
  );
};

export default FreedoFeature;
